var _ellipse, _path, _ellipse2, _path2, _ellipse3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSuitableForChildren = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 30 27"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 21.458,
  cy: 8.081,
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  rx: 2.833,
  ry: 2.521
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m19.864 20.684.177 1.26h2.834l.708-5.041H25v-1.89c0-1.194-.758-2.285-1.958-2.819s-2.636-.419-3.709.297"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 7.291,
  cy: 8.081,
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  rx: 2.833,
  ry: 2.521
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m8.886 20.684-.178 1.26H5.875l-.708-5.041H3.75v-1.89c0-1.194.758-2.285 1.958-2.819s2.635-.419 3.709.297"
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 14.375,
  cy: 11.232,
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  rx: 2.125,
  ry: 1.89
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M14.375 14.383c-1.956 0-3.542 1.41-3.542 3.15v.63h1.417l.708 3.782h1.417M14.375 14.383c1.956 0 3.542 1.41 3.542 3.15v.63H16.5l-.708 3.782h-1.417"
})));
export default SvgSuitableForChildren;